import Vue from 'vue';
import VueI18n from 'vue-i18n';

import es from './es.json';
import pt from './pt.json';

Vue.use(VueI18n);

const language = sessionStorage.getItem('language') || 'pt-BR';

export default new VueI18n({
  locale: language as string,
  fallbackLocale: 'pt-BR',
  messages: {
    'es-AR': es,
    'pt-BR': pt,
  },
});
